import React, { useState, useEffect } from 'react'
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown, IoIosArrowUp, IoIosArrowForward } from "react-icons/io";
import { FaFilter, FaCogs } from "react-icons/fa";
import { TbReload, TbArrowsSort } from "react-icons/tb";
import { MdDelete } from "react-icons/md";
import { RiAddLargeFill } from "react-icons/ri";
import { PiSignInBold } from "react-icons/pi";
import Modal from './Modal';
import qrcode from 'qrcode';
import { FaRegEdit } from "react-icons/fa";

const API_URL = process.env.REACT_APP_API_URL || "https://wa-api.globebot.io";

function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        );
        return JSON.parse(jsonPayload);
    } catch { return {}; }
}

function getUserIdFromToken() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
    }
    return { userId: null, token: null };
}

function Qrcode() {
    const { userId, token } = getUserIdFromToken();

    const [showfilter, setShowfilter] = useState(false);
    const [messageTextFilter, setMessageTextFilter] = useState(''); // <- Renamed and repurposed for message text filter
    const [WabaNumber, setWabaNumber] = useState('');
    const [wabadata, setWabadata] = useState([]);
    const [users, setUsers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [usersPerPage] = useState(10);
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [qrModal, setQrModal] = useState({ open: false, qrImage: null, qrType: '', waUrl: '' });
    const [formData, setFormData] = useState({
        Channel: "",
        Qrtype: "png",
        Message: "",
    });
    const [editFormData, setEditFormData] = useState({
        id: "",
        Channel: "",
        Qrtype: "png",
        Message: "",
    });

    // Fetch user's WABA list
    useEffect(() => {
        if (!token) return;
        fetch(`${API_URL}/auth/my-whatsapp`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(res => res.json())
            .then(data => {
                // The API response itself is the array, not under a "data" key
                if (Array.isArray(data)) {
                    setWabadata(data);
                } else if (data && Array.isArray(data.data)) {
                    // Fallback if API changes
                    setWabadata(data.data);
                } else {
                    setWabadata([]);
                }
            })
            .catch(() => setWabadata([]));
    }, [token]);

    // Fetch all QR links filtered by WabaNumber
    useEffect(() => {
        if (!token || !wabadata.length) return;
        let selectedWaba =
            WabaNumber && WabaNumber !== ''
                ? wabadata.find(w => w["WABA Number"] === WabaNumber)
                : wabadata[0];

        if (!selectedWaba?.waba_id) {
            setUsers([]);
            return;
        }

        fetch(`${API_URL}/auth/waba-qr/${selectedWaba.waba_id}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(res => res.json())
            .then(resp => {
                // API returns { success, data: [...] }
                if (resp && resp.success && Array.isArray(resp.data)) {
                    setUsers(resp.data);
                } else {
                    setUsers([]);
                }
            })
            .catch(() => setUsers([]));
    }, [wabadata, token, modalOpen, editModalOpen, WabaNumber]);

    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;

    // Apply table filter - MESSAGE TEXT ONLY
    const filteredUsers = users.filter(u =>
        (!messageTextFilter || (u.message && u.message.toLowerCase().includes(messageTextFilter.toLowerCase())))
    );
    const filterUser = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
    const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

    // Handlers for inline toggles, delete, etc
    const chatAssign = (id) => {
        setUsers((prev) =>
            prev.map((user) =>
                user.id === id ? { ...user, AllChatAssign: !user.AllChatAssign } : user
            )
        );
    };

    const deleteItem = async (id) => {
        if (!window.confirm("Delete this QR entry?")) return;
        try {
            const resp = await fetch(`${API_URL}/auth/waba-qr/${id}`, {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const data = await resp.json();
            if (data && data.success) {
                setUsers(prev => prev.filter(item => item.id !== id));
            } else {
                alert(data.error || 'Delete failed.');
            }
        } catch (err) {
            alert("Failed to delete: " + (err?.message || ""));
        }
    };

    // --- QR Add Modal State ---
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(f => ({ ...f, [name]: value }));
    };

    // --- QR Edit Modal State ---
    const handleEditChange = (e) => {
        const { name, value, } = e.target;
        setEditFormData(f => ({ ...f, [name]: value }));
    };

    // Open QR popup modal when clicking on QR link
    const handleShowQr = async (user) => {
        const url = user.qrlink;
        if (!url || typeof url !== 'string' || !url.trim()) return;
        try {
            let qrData = await qrcode.toDataURL(url); // Always returns PNG base64
            if (qrData) {
                setQrModal({
                    open: true,
                    qrImage: qrData,
                    qrType: "png",   // Always png as per toDataURL
                    waUrl: url.trim()
                });
            } else {
                alert('Could not fetch QR code.');
            }
        } catch (err) {
            alert("Failed to generate QR code: " + (err?.message || ''));
        }
    };

    // Add new QR Code
    const handleSubmit = async (e) => {
        e?.preventDefault?.();
        const { Channel, Qrtype, Message } = formData;
        if (!Channel || !Qrtype ) {
            alert("All fields except Message are required!");
            return;
        }
        try {
            const resp = await fetch(`${API_URL}/auth/waba-qr`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    wabaId: wabadata.find(w => w["WABA Number"] === Channel)?.waba_id,
                    number: Channel.replace(" ", "").replace("+", ""),
                    message: Message,
                    type: Qrtype.toLowerCase()
                })
            });
            const res = await resp.json();
            if (res.success) {
                setModalOpen(false);
                setFormData({ Channel: "", Qrtype: "png", Message: "", Number: "" });
            } else {
                alert(res.error || "Failed to create QR code.");
            }
        } catch (err) {
            alert("Failed to submit: " + (err?.message || ""));
        }
    };

    // Open edit modal and prefill data
    const openEditModal = user => {
        setEditingUser(user);
        
        // Find the matching WABA entry by comparing the number field
        const matchedWaba = wabadata.find(w => 
            w["WABA Number"]?.replace(/\s|\+/g, '') === String(user.number)?.replace(/\s|\+/g, '')
        );
    
        setEditFormData({
            id: user.id,
            Channel: matchedWaba ? matchedWaba["WABA Number"] : "",
            Qrtype: (user.type || "png").toLowerCase(),
            Message: user.message || "",
        });
        setEditModalOpen(true);
    };

    // Edit QR Code submit
    const handleEditSubmit = async (e) => {
        e?.preventDefault?.();
        const { id, Channel, Qrtype, Message } = editFormData;
        if (!id || !Channel || !Qrtype) {
            alert("All fields except Message are required!");
            return;
        }
        try {
            const payload = {
                wabaId: wabadata.find(w => w["WABA Number"] === Channel)?.waba_id,
                number: Channel.replaceAll(" ", "").replace("+", ""),
                message: Message,
                type: Qrtype.toLowerCase()
            };
            const resp = await fetch(`${API_URL}/auth/waba-qr/${id}`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });
            const res = await resp.json();
            if (res.success) {
                setEditModalOpen(false);
                setEditingUser(null);
                setEditFormData({ id: "", Channel: "", Qrtype: "png", Message: "" });
            } else {
                alert(res.error || "Failed to update QR code.");
            }
        } catch (err) {
            alert("Failed to submit: " + (err?.message || ""));
        }
    };

    // Modal for QR popup
    const renderQrModal = () => (
        <Modal isOpen={qrModal.open} onClose={() => setQrModal({ open: false, qrImage: null, qrType: '', waUrl: '' })} heading="QR Code">
            <div className="flex flex-col items-center p-2">
                <div className="mb-2 text-center text-sm text-gray-700">Scan or download your QR</div>
    
                <img src={qrModal.qrImage} alt="QR Code" style={{ width: 200, height: 200 }} />
    
                <div className="flex gap-3 mt-4">
                    <a
                        href={qrModal.qrImage}
                        download="waba-qr.png"
                        className='px-3 py-1 border border-[#37715d] rounded bg-[#37715d] text-white text-xs font-semibold hover:bg-[#285445]'
                    >
                        Download
                    </a>
                    <button
                        onClick={() => setQrModal({ open: false, qrImage: null, qrType: '', waUrl: '' })}
                        className='px-3 py-1 border border-[#3f7fca] rounded text-[#3f7fca] text-xs font-semibold hover:bg-[#3f7fca] hover:text-white'
                    >Close</button>
                </div>
                
                   <a href={qrModal.waUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block mt-4 text-blue-600 text-xs underline"
                >Open WhatsApp link</a>
            </div>
        </Modal>
    );

    // Modal for Edit QR
    const renderEditModal = () => (
        <Modal isOpen={editModalOpen} onClose={() => { setEditModalOpen(false); setEditingUser(null); }} heading={'Edit QR Code'}>
            <form className='py-1 px-4 w-full dark:bg-[#121519]' onSubmit={handleEditSubmit}>
                <div className='flex flex-wrap gap-2'>
                    <div className='w-full flex flex-col gap-1'>
                        <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Channels</label>
                        <select
                            name="Channel"
                            value={editFormData.Channel}
                            onChange={handleEditChange}
                            className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            required
                        >
                            <option value="">Select Channel</option>
                            {wabadata.map((w, i) => (
                                <option key={w["WABA Number"] || i} value={w["WABA Number"]}>
                                    {w["WABA Number"]}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className='w-full flex flex-col gap-1'>
                        <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>QR Type</label>
                        <select
                            name="Qrtype"
                            value={editFormData.Qrtype}
                            onChange={handleEditChange}
                            className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            required
                        >
                            <option value="png">PNG</option>
                            <option value="svg">SVG</option>
                        </select>
                    </div>
                    <div className='w-full flex flex-col gap-1'>
                        <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Message Text</label>
                        <input
                            name="Message"
                            value={editFormData.Message}
                            onChange={handleEditChange}
                            placeholder='Optional WhatsApp Message'
                            className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            type="text"
                        />
                    </div>
                    <div className='w-full flex items-center justify-end gap-1 mt-4'>
                        <button
                            type="submit"
                            className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 gap-2 bg-[#37715d] text-[#fff] w-full sm:w-auto'
                        >
                            <span className='text-[12px] font-bold'>Save</span>
                        </button>
                        <button
                            type="button"
                            onClick={() => { setEditModalOpen(false); setEditingUser(null); }}
                            className='flex items-center justify-end border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                        >
                            <span className='text-[12px] font-bold'>Close</span>
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );

    return (
        <>
            <div className='dark:bg-[#121519] h-[100vh] px-4'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 '>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>QR Links</h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  
                        <span>Home</span> <IoIosArrowForward />
                        <span>Manage QR Links</span>
                    </div>
                </div>
                <button
                    onClick={() => setModalOpen(true)}
                    className='bg-[#448c74] text-[#fff] text-[13px] font-semibold flex items-center gap-2 rounded-md p-2 mt-2'>
                    <RiAddLargeFill className='font-bold text-[16px]' />
                    Add QRCode
                </button>
                <div onClick={() => setShowfilter(!showfilter)}
                    className='w-[100%] flex justify-between  px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4'>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        <RiCollapseDiagonalLine />
                        Filter Records
                    </div>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                    </div>
                </div>
                {showfilter &&
                    <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519] z-20'>
                        <div className='w-[100%] flex flex-wrap gap-4'>
                            <div className='w-full sm:w-[32%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>WABA Number:</label>
                                <select
                                    value={WabaNumber}
                                    onChange={e => { setWabaNumber(e.target.value); setCurrentPage(1); }}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                >
                                    <option value="">All WABA Numbers</option>
                                    {wabadata.map((w, i) =>
                                        <option key={w["WABA Number"] || i} value={w["WABA Number"]}>
                                            {w["WABA Number"]}
                                        </option>
                                    )}
                                </select>
                            </div>
                            <div className='w-full sm:w-[32%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Message Text:</label>
                                <input
                                    value={messageTextFilter}
                                    onChange={e => setMessageTextFilter(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    placeholder='Enter message text'
                                    type="text"
                                />
                            </div>
                            <div className='w-full sm:w-[32%] flex items-center gap-1 mt-4'>
                                <button
                                    className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'
                                    onClick={e => { e.preventDefault(); setCurrentPage(1); }}
                                    type="button"
                                >
                                    <FaFilter /> <span className='text-[12px] font-bold'>Filter</span>
                                </button>
                                <button
                                    className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                                    onClick={() => {
                                        setMessageTextFilter('');
                                        setWabaNumber('');
                                    }}
                                    type="button"
                                >
                                    <TbReload /> <span className='text-[12px] font-bold'>Clear Filter</span>
                                </button>
                            </div>
                        </div>
                    </div>
                }
                <table className="w-full overflow-hidden border-[1px] border-[#dee2e6] relative ">
                    <thead>
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>WABA Number</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>QR Links</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Created On</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Message Text</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            
                            <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6] ">
                                <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Actions</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {filterUser.length > 0 ? (
                            filterUser.map((user) => (
                                <tr
                                    key={user.id}
                                    className="text-gray-500 odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#edf1f5]"
                                >
                                    {/* WABA Number (user.number) */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">
                                        {user.number}
                                    </td>
                                    {/* QR Link - as 'Show QR' button, passes full user (may use qrlink as needed) */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">
                                        
                                        <button
                                            className="text-[#448c74] font-semibold underline text-xs"
                                            onClick={() => handleShowQr(user)}
                                        >
                                           {user.qrlink}
                                        </button>
                                    </td>
                                    {/* Created On (ISO date, formatted) */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">
                                        {user.created_at
                                            ? new Date(user.created_at).toLocaleDateString()
                                            : ""}
                                    </td>
                                    {/* Message Text */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">
                                        {user.message}
                                    </td>
                                   
                                    {/* Actions */}
                                    <td className="p-1 text-[11px] border-[1px] flex gap-1 items-center border-[#dee2e6] dark:text-[#fff] ">
                                    <button
                                            className='p-1 border-[1px] border-[#448c74] rounded-md text-[#448c74] hover:text-[#fff] hover:bg-[#448c74]'
                                            onClick={() => openEditModal(user)}
                                        >
                                            <FaRegEdit />
                                       
                                        </button>
                                        <button
                                            onClick={() => deleteItem(user.id)}
                                            className='p-1 border-[1px] border-[#ed5050] rounded-md text-[#ed5050] hover:text-[#fff] hover:bg-[#ed5050]'>
                                            <MdDelete />
                                        </button>
                                        
                                        
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan="6" className="p-1 text-[11px]">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div className='flex justify-between w-[100%]'>
                    <p className='text-[11px] text-[#3f7fc8] mt-2'>
                        Showing {indexOfFirstUser + 1} to {Math.min(indexOfLastUser, filteredUsers.length)} of {filteredUsers.length} records
                    </p>
                    <div className="flex justify-center mt-4 space-x-3 relative z-0">
                        <button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(prev => prev - 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition "
                        >
                            Prev
                        </button>
                        <p className='text-[11px] text-[#3f7fc8] mt-2'> {currentPage} page of  {totalPages}  pages</p>
                        <button
                            disabled={currentPage === totalPages || totalPages === 0}
                            onClick={() => setCurrentPage(prev => prev + 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>

            {/* Modal for creating new QR */}
            <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} heading={'Add QR Code'}>
                <form className='py-1 px-4 w-full dark:bg-[#121519]' onSubmit={handleSubmit}>
                    <div className='flex flex-wrap gap-2'>
                        <div className='w-full flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Channels</label>
                            <select
                                name="Channel"
                                value={formData.Channel}
                                onChange={handleChange}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                required
                            >
                                <option value="">Select Channel</option>
                                {wabadata.map((w, i) => (
                                    <option key={w["WABA Number"] || i} value={w["WABA Number"]}>
                                        {w["WABA Number"]}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className='w-full flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>QR Type</label>
                            <select
                                name="Qrtype"
                                value={formData.Qrtype}
                                onChange={handleChange}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                required
                            >
                                <option value="png">PNG</option>
                                <option value="svg">SVG</option>
                            </select>
                        </div>
                        <div className='w-full flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Message Text</label>
                            <input
                                name="Message"
                                value={formData.Message}
                                onChange={handleChange}
                                placeholder='Optional WhatsApp Message'
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                type="text"
                            />
                        </div>
                        <div className='w-full flex items-center justify-end gap-1 mt-4'>
                            <button
                                type="submit"
                                className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 gap-2 bg-[#37715d] text-[#fff] w-full sm:w-auto'
                            >
                                <span className='text-[12px] font-bold'>Save</span>
                            </button>
                            <button
                                type="button"
                                onClick={() => setModalOpen(false)}
                                className='flex items-center justify-end border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                            >
                                <span className='text-[12px] font-bold'>Close</span>
                            </button>
                        </div>
                    </div>
                </form>
            </Modal>

            {/* Modal for editing QR */}
            {renderEditModal()}

            {/* Modal for viewing QR Image with download */}
            {renderQrModal()}

        </>
    )
}

export default Qrcode
